import React from "react";
import Input from "@material-ui/core/Input/Input";
import './style.scss'

export default function UserDetailTextField(props) {
    function onFieldValueChange(newValue) {
        if (props.onFieldValueChange)
            props.onFieldValueChange(newValue);
    }

    if (props.isEditEnabled)
        return (
            <div className="user-detail-text-field">
                {
                    props.isRequired && !props.value ?
                        <div className="user-detail-input-required-sign">*</div>
                        :
                        null
                }
                <Input error={props.isError}
                       placeholder={props.displayName} value={props.value || ""}
                       onChange={e => onFieldValueChange(e.target.value)}
                       className="user-detail-input"/>
            </div>
        );

    return (
        <React.Fragment>
            {props.value}
        </React.Fragment>
    );
}